export *from './pivot.component';
export *from './pivot_loader';


// WEBPACK FOOTER //
// ./app/insa-pivot/index.ts